import { useState } from 'react';
import { staffApi, formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';

// Goodwill/bonus tiffins — always additive, tracked separately from the normal plan credits.
export function BonusTiffinsDialog({ open, onOpenChange, subscriptionId, customerName, onDone }) {
  const [amount, setAmount] = useState('5');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    const parsed = parseInt(amount);
    if (!parsed || parsed <= 0) {
      toast.error('Enter a positive number of tiffins');
      return;
    }
    setBusy(true);
    try {
      await staffApi.post(`/subscriptions/${subscriptionId}/bonus`, { amount: parsed, reason });
      toast.success(`${parsed} bonus tiffins added`);
      setReason('');
      onDone();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="bonus-tiffins-dialog">
        <DialogHeader>
          <DialogTitle>Add Bonus Tiffins for {customerName}</DialogTitle>
          <DialogDescription>
            Free goodwill tiffins — added on top of their plan and shown separately on their account.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Number of Tiffins</Label>
            <Input
              type="number"
              min={1}
              data-testid="bonus-tiffins-amount-input"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <Label>Reason (optional)</Label>
            <Textarea
              data-testid="bonus-tiffins-reason-input"
              placeholder="e.g. Apology for a late delivery"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            data-testid="bonus-tiffins-confirm-btn"
            disabled={busy}
            onClick={confirm}
            className="bg-coriander hover:bg-coriander/90"
          >
            {busy ? 'Adding…' : 'Add Bonus Tiffins'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
